import { DEFAULT_OPERATOR_CONFIGS, initialRulesConfigState } from "./rulesConfig";

const DEFAULT_RULE_DURATION = initialRulesConfigState.increaseCase.rules[0].rule_duration;

export default function convertAPIdataToStateConfigs(inputArray) {
    const outputObject = {
      increaseCase: {
        rules: [],
        maxRules: 2,
        caseHeading: "Increase Case",
      },
      decreaseCase: {
        rules: [],
        maxRules: 2,
        caseHeading: "Decrease Case",
      },
      pauseCase: {
        rules: [],
        maxRules: 1,
        caseHeading: "Pause Case",
      },
    };

    if (!Array.isArray(inputArray)) {
      return outputObject;
    }

    inputArray.forEach((rule) => {
      const ruleData = {
        isDisabled: false,
        filters: filterMapper(rule?.entity_metric_filter?.filters) ?? [],
        rule_duration: convertTimeString(rule?.entity_metric_filter?.time_period),
      };
      const entity_type_wise_percentage_change_and_threshold = rule?.rule_action_config?.entity_action_config?.entity_type_wise_percentage_change_and_threshold;
      const actionType = rule?.rule_action_config?.entity_action_config?.action_type;

      switch (actionType) {
        case "INCREASE_BID":
          ruleData.increase_bid = rule?.rule_action_config?.entity_action_config?.percentage_change;
          ruleData.isMatchTypeSelected = entity_type_wise_percentage_change_and_threshold ? Object.keys(entity_type_wise_percentage_change_and_threshold).length > 0 : false
          ruleData.match_type_values = {
            exact: entity_type_wise_percentage_change_and_threshold?.exact?.percentage_change?.toString() ?? '',
            broad: entity_type_wise_percentage_change_and_threshold?.broad?.percentage_change?.toString() ?? '',
            phrase: entity_type_wise_percentage_change_and_threshold?.phrase?.percentage_change?.toString() ?? '',
          };
          outputObject.increaseCase.rules.push(ruleData);
          break;
        case "DECREASE_BID":
          ruleData.decrease_bid = rule?.rule_action_config?.entity_action_config?.percentage_change;
          ruleData.isMatchTypeSelected = entity_type_wise_percentage_change_and_threshold ? Object?.keys(entity_type_wise_percentage_change_and_threshold).length > 0 : false;
          ruleData.match_type_values = {
            exact: entity_type_wise_percentage_change_and_threshold?.exact?.percentage_change?.toString() ?? '',
            broad: entity_type_wise_percentage_change_and_threshold?.broad?.percentage_change?.toString() ?? '',
            phrase: entity_type_wise_percentage_change_and_threshold?.phrase?.percentage_change?.toString() ?? '',
          };
          outputObject.decreaseCase.rules.push(ruleData);
          break;
        case "PAUSE":
          outputObject.pauseCase.rules.push(ruleData);
          break;
        default:
          // Handle other action types if needed
          break;
      }
    });
  
    return outputObject;
  }

function filterMapper(filters) {
  const metricData = [
    "Spends",
    "Orders",
    "Clicks",
    "ROAS",
    "CVR",
    "CPC",
    "CTR",
    "Revenue",
  ];

  if (!Array.isArray(filters)) {
    return [];
  }

  return filters.map((filter) => {
    const fieldName = metricData?.find((metric) =>
      metric?.toLowerCase().includes(filter?.field_name)
    );
    return {
      ...filter,
      field_name: fieldName,
      operator: DEFAULT_OPERATOR_CONFIGS[filter?.operator],
    };
  });
}

function convertTimeString(inputString) {
  if (!inputString || typeof inputString !== "string") {
    return DEFAULT_RULE_DURATION;
  }

  const match = inputString.match(/LAST_(\d+)_DAY/i);

  if (match?.[1]) {
    const numberOfDays = parseInt(match[1], 10);
    return numberOfDays === 1 ? "1 Day" : `${numberOfDays} Days`;
  }

  return DEFAULT_RULE_DURATION;
}
  